export default function ProjectHeading() {
  return (
    <>
      <div className="w-full text-center bg-[#fedad3] text-black font-bold pt-40 p-20">
        <h1 className="text-5xl"> Our Gallery</h1>
      </div>
    </>
  );
}
